import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";
export default class StatsCount extends Fragment {
    summarize(summaryContext) {
        const message = "";
        return new FragmentSummary(message);
    }
}
